import { Directive } from '@angular/core';

@Directive({
    selector: '[app-table-header]',
    host: { class: 'data-table-header' },
    standalone: false
})
export class TableHeaderDirective {}
